import React from 'react';
import { View, Text, ScrollView } from 'react-native-web';
import { connect } from 'react-redux';

import get from "../../api/methods/get";
import { GET_USER_AVATAR } from "../../api/userEndpoints";
import { updateUserAsync, userUpdate, refreshUserAvatar } from "../../redux/actions";

import Colors from "../../constants/Colors";

import NavBar from "../../components/NavBar";
import { UserAvatarEdit, Input, ButtonWithSpinner, InformationDialogue } from "../../components";

class ProfileScreen extends React.Component {

	state = {
		userName: '',
		userNickname: '',
		userAvatar: null,

		isSending: false,
		showSuccessModal: false,
		showErrorModal: false,

		isFetchingAvatar: false,
	};


	getAvatar = async () => {
		if (this.state.isFetchingAvatar) return;
		this.setState({ isFetchingAvatar: true });

		try {

			const userId = this.props.userId;
			let userAvatar = await get(GET_USER_AVATAR(userId), this.props.authToken);
			let userAvatarJson = await userAvatar.json();

			this.setState({
				userAvatar: userAvatarJson.data
			});

		} catch (e) {
		    console.log(e);
		}

		this.setState({ isFetchingAvatar: false });
	};


	handleSend = async () => {
		if (this.state.isSending) return;
		this.setState({ isSending: true });

		const { userId, authToken } = this.props;
		let { userName, userNickname, userAvatar } = this.state;

		if (userName === '') { userName = this.props.userName }
		if (userNickname.trim() === '') { userNickname = this.props.nickName }

		try {

			await this.props.updateUserAsync(
				userId,
				userName,
				userNickname,
				userAvatar,
				authToken
			);
			this.setState({ showSuccessModal: true });
		} catch (e) {
			console.log(e);
			this.setState({ showErrorModal: true })
		}

		this.setState({ isSending: false });
	};

	componentDidMount() {
		this.getAvatar();
	};


	render() {
		const { userId, userName, nickName, avatarColor } = this.props;

		return (
			<NavBar title={'Perfil'}>

				<InformationDialogue
					isModalVisible={this.state.showErrorModal}
					titleText={"Erro"}
					descriptionText={"Aconteceu um erro ao editar o avatar! Tente novamente mais tarde."}
					onClose={() => this.setState({ showErrorModal: false })}
				/>

				<InformationDialogue
					isModalVisible={this.state.showSuccessModal}
					titleText={"Sucesso"}
					descriptionText={"Avatar editado com sucesso!"}
					onClose={() => this.setState({ showSuccessModal: false })}
				/>

				<ScrollView contentContainerStyle={{
					marginTop: 30,
					marginBottom: 30,
					alignItems: 'center',
					width: '100%',
				}}>
					<UserAvatarEdit
						onImageDataChange={(image) => this.setState({ userAvatar: image })}
						userAvatarColor={this.props.avatarColor}
						userAvatarUri={this.state.userAvatar}
						userName={this.props.userName}
						userEmail={this.props.email}
						avatarPropsStyle={{ width: 150, height: 150, borderRadius: 80 }}
					/>

					<Input
						label={'Nome: '}
						placeholder={this.props.userName}
						onChangeText={(input) => this.setState({ userName: input })}
						value={this.state.userName}
						autoCapitalize={'words'}
						containerStyle={{ marginBottom: 5 }}
						placeholderTextColor={Colors.fontColorOnBackground}
						inputStyle={{ color: Colors.fontColorOnBackground }}
					/>

					<Input
						label={'Apelido: '}
						placeholder={this.props.nickName}
						onChangeText={(input) => this.setState({userNickname: input})}
						value={this.state.userNickname}
						autoCapitalize={'words'}
						containerStyle={{ marginBottom: 5 }}
						placeholderTextColor={Colors.fontColorOnBackground}
						inputStyle={{ color: Colors.fontColorOnBackground }}
					/>

					<ButtonWithSpinner
						isLoading={this.state.isSending}
						text={'Atualizar'}
						onPress={this.handleSend}
						containerPropsStyle={{
							backgroundColor: Colors.buttonColor,
							borderWidth: 0,
							margin: 10,
							borderRadius: 8,
							height: 40
						}}
						textPropsStyle={{ fontWeight: 'bold', fontSize: 16 }}
					/>


				</ScrollView>
			</NavBar>
		);
	}
}

const mapStateToProps = state => {
	return {
		userId: state.user.userId,
		userName: state.user.userName,
		nickName: state.user.nickname,
		avatarColor: state.user.avatarColor,
		// authToken: state.auth.authData.IdToken,
	}
};


export default connect(mapStateToProps, { updateUserAsync, userUpdate, refreshUserAvatar })(ProfileScreen);

